import { useToggle } from "utils/Hooks"
import { FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { LeftArrow, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import { Body, BodySmall } from "components/views/atoms/Bodies"
import { TextLink } from "components/views/atoms/links/TextLink"
import { Checkbox } from "components/views/atoms/Checkbox"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"
import { FeatureConfiguration } from "types/benefitConfiguration"
import { buildMultiElementListString } from "utils/copy/buildMultiElementListString"
import { DetailedInformationModal } from "components/views/modal/DetailedInformationModal"

type HealthTopic = {
  text: string
  filter?: (config: FeatureConfiguration) => void
}

const healthTopics: HealthTopic[] = [
  {
    text: "health"
  },
  {
    text: "sexual orientation",
    filter: (c) => c.isLibraryEnabled
  }
]

export const HealthConsent = ({
  isSubmitting,
  healthConsent,
  setHealthConsent,
  onBack,
  onComplete,
  benefitConfiguration
}) => {
  const [showDetailedInfoModal, toggleDetailedInfoModal] = useToggle()
  const filteredHealthTopics = healthTopics
    .filter((t) => !t.filter || t.filter(benefitConfiguration))
    .map((t) => t.text)

  const healthTopicsCopyList = buildMultiElementListString(filteredHealthTopics)

  return (
    <FleLayout
      modal={
        showDetailedInfoModal ? (
          <DetailedInformationModal benefitConfiguration={benefitConfiguration} onClose={toggleDetailedInfoModal} />
        ) : null
      }
    >
      <TopSection progressStep={1} leftOrBackArrow={<LeftArrow onClick={onBack} />} />
      <SwitchH2ToBodyLarge>Consent for processing your personal data</SwitchH2ToBodyLarge>
      <Spacer height={1} />
      <BodySmall color="black-80">
        During this registration process and as we provide services, Carrot Fertility, Inc. (located in the USA) may ask
        you for your Personal Data, which is data about your {` ${healthTopicsCopyList}`}.
      </BodySmall>
      <Spacer height={0.5} />
      <BodySmall color="black-80">
        In order to provide services, we need your consent to process your Personal Data. Our services include:
        providing information and recommendations, and processing reimbursements.
      </BodySmall>
      <Spacer height={1} />
      <BodySmall color="black-80">
        You may withdraw consent at any time with effect for the future by contacting info@get-carrot.com.&nbsp;
        <TextLink underlineColor="black-80" onClick={toggleDetailedInfoModal}>
          Read more
        </TextLink>{" "}
        {
          "on the type of data we collect, how we process that data, what it's used for, and why it matters that we're located in the USA."
        }
      </BodySmall>
      <Spacer height={1} />
      <BodySmall color="black-80">
        By giving consent, you confirm that you’ve read and understood the above explanation and additional disclosures
        made available to you. You agree to Carrot collecting and processing data regarding your
        {` ${healthTopicsCopyList} `}
        as described.
      </BodySmall>
      <Spacer height={1} />
      <label>
        <div className="flex flex-row">
          <Checkbox checked={healthConsent} onChange={(e) => setHealthConsent(e.target.checked)} />
          <div className="ml2">
            <Body>Yes, I give my consent.</Body>
          </div>
        </div>
      </label>
      <FleLinkWrapper spacerHeight={1.5}>
        <ArrowLink onClick={onComplete} enabled={healthConsent && !isSubmitting}>
          Continue
        </ArrowLink>
      </FleLinkWrapper>
    </FleLayout>
  )
}
